<template>
    <main class="main-content" id="main-content">
        <div class="container">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("booking")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="section__nav reservation-nav">
                <div class="btn-group btn-group_double"><router-link class="btn btn_default btn_green btn_with-icon" to="/"><span class="btn__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-home"></use>
                      </svg></span><span class="btn__text">{{$t("toMain")}}</span></router-link><router-link class="btn btn_default btn_white btn_with-icon" to="/reservation-select"><span class="btn__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-pause"></use>
                      </svg></span><span class="btn__text">{{$t("booking")}}</span></router-link></div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="reservation box bg-white">
                    <div class="reservation__title section__title section__title_style3">Услуга “бронирование” для интернета</div>
                    <ul class="list list_unstyled reservation__params">
                      <li class="list__item">
                        <div class="list__title color-gray">Период бронирования составил:</div>
                        <div class="list__value">150 Мбит/c</div>
                      </li>
                      <li class="list__item">
                        <div class="list__title color-gray">Плата за бронирование:</div>
                        <div class="list__value">1 230 тенге</div>
                      </li>
                    </ul>
                    <button class="btn btn_default btn_green js-reservation-revoke" type="button">Отменить бронирование</button>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="reservation box bg-white">
                    <div class="reservation__title section__title section__title_style3">Услуга “бронирование” для телевидения</div>
                    <ul class="list list_unstyled reservation__params">
                      <li class="list__item">
                        <div class="list__title color-gray">Период бронирования составил:</div>
                        <div class="list__value">150 Мбит/c</div>
                      </li>
                      <li class="list__item">
                        <div class="list__title color-gray">Плата за бронирование:</div>
                        <div class="list__value">1 230 тенге</div>
                      </li>
                    </ul>
                    <button class="btn btn_default btn_green js-reservation-revoke" type="button">Отменить бронирование</button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
    </main>
</template>
<script>
import PageHeader from "@/components/PageHeader";
// import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  components: {
    PageHeader
  }
}
</script>
<style scoped>

</style>